export const calculateAmountDue = (price: number, credit: number) => {
  if (credit >= price) return 0

  if (credit <= 0) return price

  return price - credit
}
